import { useLocation } from "react-router-dom";
import { FloatingCalculator } from "./FloatingCalculator";
import { FloatingInvoiceButton } from "./FloatingInvoiceButton";

export const FloatingButtons = () => {
  const location = useLocation();
  const isInventoryMode = location.pathname.startsWith('/inventory') || location.pathname.startsWith('/app/inventory');

  return (
    <>
      <FloatingCalculator />
      {isInventoryMode && <FloatingInvoiceButton />}
    </>
  );
};
